.dialog {
  inline-size: calc(var(--mtds-30) * 4);
  max-inline-size: calc(100vw - var(--mtds-8));
  overflow-wrap: anywhere;
}

.table {
  inline-size: 100%;
  overflow-wrap: anywhere;
}
